import { useEffect } from 'react';

/**
 * Every route gets its own `<title>` (WCAG 2.4.2). `index.html` ships one static string and
 * nothing else ever wrote to it, so every screen in the tab bar and every browser-history
 * entry read "Portal — BoardPandas" regardless of which page was open.
 */
export function useDocumentTitle(pageTitle: string): void {
  useEffect(() => {
    document.title = `${pageTitle} · Projects — BoardPandas`;
  }, [pageTitle]);
}
